module.exports = __webpack_public_path__ + "static/media/bali-bombings-feature-banner-md@2x.4f5b4343.webp";